import type { ReactNode } from 'react'
import { es } from '@/textos/es'

/** Pantalla dividida: marca a la izquierda (solo escritorio) y formulario a la derecha. */
export function LayoutAcceso({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen bg-fondo">
      <section className="hidden flex-1 flex-col gap-8 bg-rey-900 px-14 py-12 text-white lg:flex">
        <div className="flex items-baseline gap-2">
          <span className="text-[32px] font-extrabold italic leading-none tracking-[-0.02em]">
            UNIPER
          </span>
          <span className="text-small font-bold text-rey-300">{es.app.lugar}</span>
        </div>
        <div className="flex max-w-[520px] flex-1 flex-col justify-center gap-[18px]">
          <span className="text-meta font-bold tracking-[.14em] text-rey-300">UNIPER OPS</span>
          <h1 className="text-[40px] font-extrabold leading-[1.1] tracking-[-0.02em]">
            {es.acceso.marca}
          </h1>
          <p className="text-[16px] leading-[1.55] text-rey-200">{es.acceso.marcaDetalle}</p>
        </div>
        <span className="text-small text-rey-300">{es.acceso.lema}</span>
      </section>
      <section className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-[400px] rounded-[18px] border border-linea bg-tarjeta px-7 py-8">
          <div className="mb-8 flex items-baseline gap-2 lg:hidden">
            <span className="text-display italic text-rey-900">UNIPER</span>
            <span className="text-micro text-tinta-3">{es.app.lugar}</span>
          </div>
          {children}
        </div>
      </section>
    </div>
  )
}
